import Vue from 'vue'
import Table from "@/components/Table"
import Title from "@/components/Title"
import DialogAlert from "@/components/DialogAlert"
import DialogInventory from "@/components/DialogInventory"
import DialogEditRateToSy from "@/components/DialogEditRateToSy"
import Input from "@/components/Form Components/Input"
import FormSelect from "@/components/Form Components/FormSelect"
import FormSelectMulti from "@/components/Form Components/FormSelectMultiValue"
import FormSelectTyping from "@/components/Form Components/FormSelectTyping"
import Search from "@/components/Search"
import Button from "@/components/Button"
import Loading from "@/components/Loading"
import Stepper from "@/components/Stepper"
import DragDropImages from "@/components/DragDropImages"
import AutoComplete from "@/components/Form Components/AutoComplete"
import Switcher from "@/components/Form Components/Switcher"
import TextArea from "@/components/Form Components/TextArea"
import File from "@/components/Form Components/File"
import RadioButtonsGroup from "@/components/Form Components/RadioButtonsGroup"
import FormSlider from "@/components/Form Components/FormSlider"
import Datepicker from "@/components/Form Components/Date"
import Carousal from "@/components/Carousal"

import ReasonReject from "@/components/Form Components/ReasonReject"

import GeneralForm from "./components/Forms/GeneralForm"
import CouponForm from "./components/Forms/CouponForm"
import CreatePayPalAccount from "./components/Forms/CreatePayPalAccount"
import ConfirmBankForm from "./components/Forms/ConfirmBankForm"

import OrderForm from "./components/Forms/OrderForm"
import BankServiceForm from "./components/Forms/BankServiceForm"
import ConfirmPayForm from "./components/Forms/ConfirmPayForm"
import ConfirmPayFormUniversite from "./components/Forms/ConfirmPayFormUniversite"


import ConfirmMoneyForm from "./components/Forms/ConfirmMoneyForm"
import ConfirmForm from "./components/Forms/ConfirmForm"
import MoneyEditForm from "./components/Forms/MoneyEditForm"
import CurrencyForm from "./components/Forms/CurrencyForm"




import Filters from "@/components/FIlters/Filters"
import CouponFilter from "@/components/FIlters/components/CouponFilter"
import OrdersFilter from "@/components/FIlters/OrdersFilter"
import MoneyFilter from "@/components/FIlters/MoneyFilter"
import CustomerFilter from "@/components/FIlters/CustomerFilter"

Vue.component('Table', Table)
Vue.component('Title', Title)
Vue.component('DialogAlert', DialogAlert)
Vue.component('DialogInventory', DialogInventory)
Vue.component('DialogEditRateToSy', DialogEditRateToSy)
Vue.component('Input', Input)
Vue.component('FormSelect', FormSelect)
Vue.component('FormSelectTyping', FormSelectTyping)
Vue.component('FormSelectMulti', FormSelectMulti)


Vue.component('Search', Search)
Vue.component('Button', Button)
Vue.component('Loading', Loading)
Vue.component('Stepper', Stepper)

Vue.component('DragDropImages', DragDropImages)
Vue.component('AutoComplete', AutoComplete)
Vue.component('Carousal', Carousal)
Vue.component('Switcher', Switcher)
Vue.component('TextArea', TextArea)
Vue.component('File', File)
Vue.component('RadioButtonsGroup', RadioButtonsGroup)
Vue.component('FormSlider', FormSlider)
Vue.component('Date', Datepicker)
Vue.component('ReasonReject',ReasonReject)
Vue.component('GeneralForm', GeneralForm)
Vue.component('OrderForm', OrderForm)
Vue.component('BankServiceForm', BankServiceForm)
Vue.component('CouponForm', CouponForm)
Vue.component('CreatePayPalAccount', CreatePayPalAccount)
Vue.component('ConfirmPayForm', ConfirmPayForm)
Vue.component('ConfirmPayFormUniversite', ConfirmPayFormUniversite)

Vue.component('ConfirmBankForm', ConfirmBankForm)

Vue.component('ConfirmForm', ConfirmForm)


Vue.component('Filters', Filters)
Vue.component('CouponFilter', CouponFilter)
Vue.component('BankServiceForm', BankServiceForm)
Vue.component('CouponForm', CouponForm)
Vue.component('OrdersFilter', OrdersFilter)
Vue.component('CustomerFilter', CustomerFilter)
Vue.component('MoneyFilter', MoneyFilter)

Vue.component('ConfirmMoneyForm', ConfirmMoneyForm)
Vue.component('MoneyEditForm', MoneyEditForm)
Vue.component('CurrencyForm', CurrencyForm)


export default {}
